import WarningIcon from '@mui/icons-material/Warning';
import { Box } from '@mui/material';
import { FileField, required } from 'react-admin';
import { useWatch } from 'react-hook-form';

import { DOCUMENTS_UPLOAD_LARGE_FILE_MAX_SIZE } from '@Common/constants/documents';

import { FileInput, ShowSection, TypographyTranslated } from '@sh4res/bo-common/components';
import { DateInput } from '@sh4res/bo-common/fields/DateInput';

const expirationDateValidator = () => (value: string | Date) => {
  const expiryDate = typeof value === 'string' ? new Date(value) : value;

  if (new Date() > expiryDate) {
    return 'resources.bo_common.b2b.withdrawals.create.validation.date_of_expiry';
  }
};

const testId = 'BoExternalB2bWithdrawalsCreateDocumentsStep';

export const DocumentsStep = () => {
  const isInternationalCompany = useWatch({
    name: 'is_international',
    defaultValue: false,
  });

  return (
    <ShowSection
      leftAligned
      label="resources.bo_common.b2b.withdrawals.create.sections.documents_identity"
      noCard={true}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <WarningIcon sx={{ color: 'grey', marginTop: '3px' }} />
        <TypographyTranslated label="resources.bo_common.b2b.withdrawals.create.labels.document_identity_still_valid" />
      </Box>
      <DateInput
        data-testid={`${testId}_DateOfExpiryInput`}
        source="date_of_expiry"
        label="resources.bo_common.b2b.withdrawals.create.labels.date_of_expiry"
        validate={
          isInternationalCompany
            ? [expirationDateValidator()]
            : [required(), expirationDateValidator()]
        }
      />
      <FileInput
        data-testid={`${testId}_DocumentsIdentityInput`}
        source="documents_identity"
        accept="application/pdf,image/png,image/jpeg"
        maxSize={DOCUMENTS_UPLOAD_LARGE_FILE_MAX_SIZE}
        validate={isInternationalCompany ? undefined : required()}
        multiple={true}>
        <FileField data-testid={`${testId}_DocumentsIdentityField`} source="src" title="title" />
      </FileInput>
    </ShowSection>
  );
};
